import { ASIconButton, ComponentSize, PenIcon } from '@eleventheye/asui';
import React from 'react';

type EditButtonProps = {
  className?: string;
  onEdit?: () => void;
} & Pick<React.HTMLProps<HTMLDivElement>, 'style'>;

const EditButton: React.FC<EditButtonProps> = ({ className = '', onEdit = () => undefined, ...props }) => {
  return (
    <ASIconButton
      className={className}
      style={{ ...props.style }}
      size={ComponentSize.Medium}
      iconSize={22}
      onIconButtonTap={onEdit}
      title="EDIT"
      icon={PenIcon}
    />
  );
};

export default EditButton;
